export default "__VITE_ASSET__CmArGH81__"